<label class="checkbox" [ngClass]="checkboxClasses">
  <input type="checkbox" [hidden]="true" [formControl]="checkbox" />
  <span class="checkmark"></span>
</label>

<div class="label" (click)="toggleCheckbox()">
  <ng-content></ng-content>
</div>
